import { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import ContentTypeBadge from '../../../components/ui/ContentTypeBadge';


const DraftCard = ({ draft, onEdit, onDelete, onPublish }) => {
  const [showMenu, setShowMenu] = useState(false);

  const getCircleColor = (circle) => {
    const colors = {
      'الروح': 'bg-primary/20 text-primary',
      'الأدب': 'bg-accent/20 text-accent',
      'الشعر': 'bg-success/20 text-success',
      'الفلسفة': 'bg-warning/20 text-warning',
      'البصريات': 'bg-secondary/20 text-secondary',
      'الصوت': 'bg-primary/20 text-primary',
      'التراث': 'bg-accent/20 text-accent',
      'التصوف': 'bg-success/20 text-success'
    };
    return colors?.[circle] || 'bg-muted text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg shadow-warm hover:shadow-warm-lg transition-all duration-300 group overflow-visible">
      <div className="flex flex-col md:flex-row gap-4 p-4 md:p-5">
        {draft?.coverImage && (
          <div className="w-full md:w-32 lg:w-40 h-40 md:h-24 lg:h-28 flex-shrink-0 rounded-lg overflow-hidden">
            <Image
              src={draft?.coverImage}
              alt={draft?.coverImageAlt}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>
        )}
        
        <div className="flex-1 min-w-0 space-y-2 md:space-y-3 overflow-visible">
          <div className="flex items-start justify-between gap-3">
            <h3
              className="text-base md:text-lg lg:text-xl font-bold text-foreground line-clamp-2 group-hover:text-primary transition-colors cursor-pointer"
              onClick={() => onEdit(draft?.id)}
            >
              {draft?.title}
            </h3>
            <div className="relative flex-shrink-0 overflow-visible">
              <button
                onClick={() => setShowMenu(!showMenu)}
                className="p-1.5 md:p-2 hover:bg-muted rounded-lg transition-colors"
                aria-label="خيارات المسودة"
              >
                <Icon name="MoreVertical" size={18} className="md:w-5 md:h-5" />
              </button>
              
              {showMenu && (
                <div className="absolute left-0 top-full mt-2 bg-popover rounded-lg py-1.5 min-w-[140px] z-50 shadow-warm">
                  <button
                    onClick={() => {
                      onEdit(draft?.id);
                      setShowMenu(false);
                    }}
                    className="w-full px-4 py-2 text-right text-sm hover:bg-muted transition-colors flex items-center gap-2"
                  >
                    <Icon name="Edit" size={16} />
                    <span>تعديل</span>
                  </button>
                  <button
                    onClick={() => {
                      onPublish(draft);
                      setShowMenu(false);
                    }}
                    className="w-full px-4 py-2 text-right text-sm hover:bg-muted transition-colors flex items-center gap-2"
                  >
                    <Icon name="Send" size={16} />
                    <span>نشر</span>
                  </button>
                  <button
                    onClick={() => {
                      onDelete(draft?.id);
                      setShowMenu(false);
                    }}
                    className="w-full px-4 py-2 text-right text-sm hover:bg-muted transition-colors flex items-center gap-2 text-destructive"
                  >
                    <Icon name="Trash2" size={16} />
                    <span>حذف</span>
                  </button>
                </div>
              )}
            </div>
          </div>
          
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
            {draft?.excerpt}
          </p>
          
          <div className="flex flex-wrap items-center gap-2 md:gap-3 text-xs md:text-sm">
            <ContentTypeBadge type={draft?.type} size="sm" />
            <span className={`px-2 md:px-3 py-1 rounded-full font-medium ${getCircleColor(draft?.circle)}`}>
              {draft?.circle}
            </span>
            <div className="flex items-center gap-1 text-muted-foreground">
              <Icon name="Calendar" size={14} className="md:w-4 md:h-4" />
              <span>{draft?.lastEdited}</span>
            </div>
            <div className="flex items-center gap-1 text-muted-foreground">
              <Icon name="FileText" size={14} className="md:w-4 md:h-4" />
              <span>{draft?.wordCount} كلمة</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DraftCard;